export default "__VITE_PUBLIC_ASSET__3e903d3b__"